import { useTranslation } from 'react-i18next';
import { aiStatusLabelKey, type IChatStatus } from '@utils/aiChat';
import styles from './styles.module.css';

interface IAiStatusLineProps {
  /** The most recent `status` frame, or null before the first. */
  status: IChatStatus | null;
}

/**
 * The sentence that carries an assistant turn's wait: which source it is
 * reading, in words, and whether that read failed.
 *
 * Shared by both chat surfaces — the AI Agent page's transcript and the
 * dashboard card — so a tool's sentence, and the way a failed call reads, is
 * written once. Each surface owns what sits around it (its own dots, its own
 * bubble) and the live region it lives in: a region must be mounted BEFORE the
 * first sentence arrives to announce it, so it cannot be this component, which
 * renders nothing until then.
 */
export function AiStatusLine({ status }: IAiStatusLineProps) {
  const { t } = useTranslation();
  if (status === null) return null;
  return (
    <span className={status.failed ? `${styles.label} ${styles.failed}` : styles.label}>
      {t(aiStatusLabelKey(status.label))}
      {status.failed && <span className={styles.failedNote}>{t('aiAgent.status.failedNote')}</span>}
    </span>
  );
}
